import { Text } from "../../../../../../Atomics/Text";

const FamilyTypeText = ({ isTextForModal, disable, children }) => {

    return isTextForModal ?
        <Text
            $fontColor='coolgray-10'
            $fontSize="text_xs"
            $weight="medium"
            style={{
                textDecoration: disable ? "line-through" : "none",
            }}
        >
            {children}
        </Text>
        :
        <Text
            $fontColor="coolgray-12"
            $fontSize="text_md"
            $weight="medium"
            style={{
                textDecoration: disable ? "line-through" : "none",
            }}>
            {children}
        </Text>

}

export default FamilyTypeText;